import { cn } from '@/lib/utils';
import { ReactNode, HTMLAttributes, forwardRef } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  className?: string;
  hover?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const paddingStyles = {
  none: '',
  sm: 'p-4',
  md: 'p-6',
  lg: 'p-8',
};

export const Card = forwardRef<HTMLDivElement, CardProps>(function Card(
  { children, className, hover = false, padding = 'md', ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        hover ? 'card-hover' : 'card',
        paddingStyles[padding],
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
});

interface CardHeaderProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function CardHeader({ title, description, action, className }: CardHeaderProps) {
  return (
    <div className={cn('flex items-start justify-between gap-4', className)}>
      <div>
        <h3 className="text-heading-3 text-secondary">{title}</h3>
        {description && (
          <p className="text-body-sm text-grey-500 mt-1">{description}</p>
        )}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}


